module.exports = __webpack_public_path__ + "img/vendor1.62211e53.png";